import { fabric } from 'fabric';

/**
 * Exposure filter class
 * Adjusts the exposure of an image by modifying brightness across all pixels
 * Similar to photography exposure compensation
 */
fabric.Image.filters.Exposure = fabric.util.createClass(
  fabric.Image.filters.BaseFilter,
  {
    type: 'Exposure',

    /**
     * Exposure value, from -1 to 1
     * -1 = very dark (underexposed)
     * 0 = no change
     * 1 = very bright (overexposed)
     */
    exposure: 0,

    /**
     * Fragment shader for WebGL rendering
     */
    fragmentSource:
      'precision highp float;\n' +
      'uniform sampler2D uTexture;\n' +
      'uniform float uExposure;\n' +
      'varying vec2 vTexCoord;\n' +
      'void main() {\n' +
      '  vec4 color = texture2D(uTexture, vTexCoord);\n' +
      // Exposure adjustment using exponential function
      // This mimics camera exposure stops
      '  float exposureFactor = pow(2.0, uExposure * 2.0);\n' +
      '  color.rgb *= exposureFactor;\n' +
      // Clamp values to prevent overflow
      '  color.rgb = clamp(color.rgb, 0.0, 1.0);\n' +
      '  gl_FragColor = color;\n' +
      '}',

    /**
     * Apply filter using Canvas 2D API
     */
    applyTo2d: function (options) {
      const imageData = options.imageData;
      const data = imageData.data;
      const exposure = this.exposure;

      // Calculate exposure factor (mimics camera exposure stops)
      const exposureFactor = Math.pow(2, exposure * 2);

      for (let i = 0; i < data.length; i += 4) {
        // Apply exposure to RGB channels
        data[i] = Math.min(255, Math.max(0, data[i] * exposureFactor)); // Red
        data[i + 1] = Math.min(255, Math.max(0, data[i + 1] * exposureFactor)); // Green
        data[i + 2] = Math.min(255, Math.max(0, data[i + 2] * exposureFactor)); // Blue
        // Alpha channel (i + 3) remains unchanged
      }
    },

    /**
     * Send uniform data to WebGL shader
     */
    getUniformLocations: function (gl, program) {
      return {
        uExposure: gl.getUniformLocation(program, 'uExposure'),
      };
    },

    /**
     * Send uniform values to WebGL shader
     */
    sendUniformData: function (gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uExposure, this.exposure);
    },

    /**
     * Returns object representation of filter
     */
    toObject: function () {
      return fabric.util.object.extend(this.callSuper('toObject'), {
        exposure: this.exposure,
      });
    },
  }
);

/**
 * Create filter instance from object representation
 */
fabric.Image.filters.Exposure.fromObject =
  fabric.Image.filters.BaseFilter.fromObject;

export default fabric.Image.filters.Exposure;
